export const GeneralError = () => (
  <div>
    <h1>General Error</h1>
    <p>Something went wrong</p>
  </div>
);